import { atom } from "jotai";
import { isPublicAtom } from "../permissions";
import { isTemplatePageAtom } from "../templates";
import { isViewerAtom } from "../canvas";

/**
 * Derived atom that determines whether the copilot should be shown in the BuilderNav and SidebarDrawer
 *
 * The copilot is shown when:
 * - NOT a public canvas
 * - NOT a template page
 * - NOT a user with can_view access only (isViewer)
 */
export const shouldCopilotBeVisibleAtom = atom((get) => {
  const isPublic = get(isPublicAtom);
  const isTemplatePage = get(isTemplatePageAtom);
  const isViewer = get(isViewerAtom);

  return !isPublic && !isTemplatePage && !isViewer;
});

shouldCopilotBeVisibleAtom.debugLabel = "shouldCopilotBeVisibleAtom";
